export default{
    user:{},
    token:'',
    msg:'',
    editar:{}
}